/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FreightBillCorrectionReason {
    Other = 0,
    IncorrectCustomer = 1,
    IncorrectRate = 2,
    AddedAccessorials = 3,
}
